import {SkillGroupBaseModel} from './skillGroupBase.model';
import {QuestionModel} from '../questions/question.model';
import {generateQuestionList} from '../questions/question-generator';

/**
 * This class extends the base model with relationships such as questions
 * which can be populated. This is done so that base model can keep being
 * used in other relationships without creating a circular dependency.
 */
export class SkillGroupExtendedModel extends SkillGroupBaseModel {

  public questions: QuestionModel[] = [];

  static generate(json: any, skillGroup: SkillGroupExtendedModel = null): SkillGroupExtendedModel {

    if (!skillGroup) {
      skillGroup = new SkillGroupExtendedModel();
    }

    /**
     * Populates the base variables by passing the variable by reference
     */
    SkillGroupBaseModel.generate(json, skillGroup);

    // Prefer populated questionIds; fall back to questions for backward compat during migration
    if (json.questionIds && json.questionIds.length > 0 && typeof json.questionIds[0] === 'object') {
      skillGroup.questions = generateQuestionList(json.questionIds);
    }

    return skillGroup;

  }

  static generateModels(jsonList: any): SkillGroupExtendedModel[] {

    const list: SkillGroupExtendedModel[] = [];
    for (const json of jsonList) {
      list.push(SkillGroupExtendedModel.generate(json));
    }

    return list;

  }

}
